<template>
    <div class="qksm qksm3">
        <p><b>（三）一般公共预算收支情况</b></p>
        <div class="nogap">
            <p>
                2021年一般公共预算当年拨款{{isMoney(T5.总计)}}万元，
                <span class="hide_pdf">
                    （去年预算数<reason type="money" classname="qksm money editLast" name="T5总计last" v-model:value="T5['总计last']"></reason>万元）
                </span>
                <span v-if="num(T5.总计).toFixed(2)==num(T5['总计last']).toFixed(2)">
                    与上年预算数相同。
                </span>
                <span v-else>
                    <span v-if="num(T5['总计last'])==0">
                        （去年预算数为0万元，无法计算增减比率），
                    </span>
                    <span v-else>
                        比上年{{growthRatioText(T5.总计,T5['总计last'])}}，
                    </span>
                    主要是<reason type="textarea" classname="qksm widest because" name="T5原因" v-model:value="qksm['T5原因']"></reason>
                </span>
            </p>
            <p>
                2021年当年一般公共预算支出预算为{{isMoney(T5.总计)}}万元，
                <span class="hide_pdf">
                    （去年预算数<reason type="money" classname="qksm money editLast" name="T5总计last" v-model:value="T5['总计last']"></reason>万元）
                </span>
                <span v-if="num(T5.总计).toFixed(2)==num(T5['总计last']).toFixed(2)">
                    与上年预算数相同
                </span>
                <span v-else>
                    <span v-if="num(T5['总计last'])==0">
                        （去年预算数为0万元，无法计算增减比率）
                    </span>
                    <span v-else>
                        比上年{{growthRatioText(T5.总计,T5['总计last'])}}
                    </span>
                </span>{{num(T5.总计)==0 ? '。' : '，其中：'}}
                <span v-for="(item,idx) in T5.leiItems" :key='idx'>
                    {{(item.f).replace("支出","")}}（类）支出{{isMoney(item.value)}}万元，占{{getPercentValue(T5.leiItems.map(e=>num(e.value)), idx, 2)}}{{idx==T5.leiItems.length-1?'。':'；'}}
                </span>
            </p>
        </div>
        <div id="myChart5" class="echart" v-if="(!isPdf && $parent.isData) || isPdf"></div>
        <div id="myChart6" class="echart" v-if="(!isPdf && $parent.isData) || isPdf"></div>
        <div class="nogap">
            <template v-if="num(T5.总计)>0">
                <p>具体情况如下：</p>
                <p v-for="(item,idx) in T5.items" :key='idx'>
                    {{T5.items.length>1 ? (idx+1)+"." :""}}{{(item.lei)}}{{item.kuan}}{{item.xiang}}支出{{isMoney(item.value)}}万元，
                    <span class="hide_pdf">
                        （去年预算数<reason type="money" classname="qksm money editLast" :name="'T5last'+item.code" v-model:value="qksm['T5last'+item.code]"></reason>万元）
                    </span>
                    <span v-if="num(item.value).toFixed(2)==num(qksm['T5last'+item.code]).toFixed(2)">
                        与上年预算数相同。
                    </span>
                    <span v-else>
                        <span v-if="num(qksm['T5last'+item.code])==0">
                            （去年预算数为0万元，无法计算增减比率），
                        </span>
                        <span v-else>
                            比上年{{growthRatioText(item.value,qksm['T5last'+item.code])}}，
                        </span>
                        主要是<reason type="textarea" classname="qksm widest because" :name="'T5原因'+item.code" v-model:value="qksm['T5原因'+item.code]"></reason>
                    </span>
                </p>
            </template>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm3",
        data() {
            var qksm = this.$store.state.divData.qksm;
            if (qksm['T5总计last'])
                this.T5['总计last'] = qksm['T5总计last'];
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm,
            }
        },
        props: {
            T5: {
                type: Object,
                default: "",
            },
        },
        computed: {
            总计last() {
                return this.isMoney(this.T5.总计last)
            }
        },
        watch: {
            总计last() {
                this.$parent.isChart()
            }
        },
        components: {
            reason,
        },
    };
</script>